import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'

import type { CheckboxOptionType, ColProps, RowProps } from 'ant-design-vue'

import type Checkbox from './checkbox.vue'

import type CheckboxGroup from './checkbox-group.vue'

const direction = ['vertical', 'horizontal'] as const

type option = CheckboxOptionType & {
  colOptions?: ColProps
  label: string
  span?: number
}
export const checkboxProps = buildProps({
  checkboxLabel: {
    type: String,
    default: '',
  },
} as const)

export const checkboxGroupProps = buildProps({
  options: {
    type: definePropType<option[]>(Array),
    default: () => [],
  },
  // 是否使用栅格布局
  useGrid: {
    type: Boolean,
    default: true,
  },

  // 栅格布局配置
  rowOptions: {
    type: definePropType<RowProps>(Object),
    default: () => {},
  },

  // 栅格项水平间距
  gutterHorizontal: {
    type: Number,
    default: 8,
  },

  // 栅格项垂直间距
  gutterVertical: {
    type: Number,
    default: 8,
  },

  // 子项占位格数
  allSpan: {
    type: Number,
    default: 6,
  },

  // 排列方向
  direction: {
    type: String,
    values: direction,
    default: 'horizontal',
  },

  // 项间距
  itemSpace: {
    type: Number,
    default: 8,
  },
} as const)

// props
export type CheckboxProps = ExtractPropTypes<typeof checkboxProps>
export type CheckboxGroupProps = ExtractPropTypes<typeof checkboxGroupProps>

// instance
export type CheckboxInstance = InstanceType<typeof Checkbox>
export type CheckboxGroupInstance = InstanceType<typeof CheckboxGroup>
